import {
  GET_PRODUCT_LIST,
  EDIT_PRODUCT,
  GET_PRODUCT_HIERARCHY,
  SYNC_PRODUCT_OVERVIEW,
  MANAGE_PRODUCT_HIERARCHY,
  DELETE_PRODUCT_HIERARCHY_NODE
} from "../constants/url";
import httpBase from "../utils/http.utils";

export const getProductListApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(GET_PRODUCT_LIST, {
        params: params,
      });
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}

export const getProductHierarchyApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(GET_PRODUCT_HIERARCHY, {
        params,
      });
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
};

export const editProductApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().put(EDIT_PRODUCT, params);
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}

export const syncProductOverviewApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(SYNC_PRODUCT_OVERVIEW, params);
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
};

export const manageProductHierarchyApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(MANAGE_PRODUCT_HIERARCHY, data);
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
};

export const moveProductHierarchyNodeApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(MANAGE_PRODUCT_HIERARCHY, {
        action: "move",
        ...data,
      });
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
};

export const deleteProductHierarchyNodeApi = ({
  hash_id,
  delete_product = false,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().delete(DELETE_PRODUCT_HIERARCHY_NODE, {
        params: { hash_id, delete_product }
      });
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
};
